/** Resolves once every image has loaded and decoded (or failed), or after `timeoutMs`. */
export const waitForImages = (
	images: Iterable<HTMLImageElement>,
	timeoutMs: number
): Promise<void> => {
	const decoded = Promise.all(
		Array.from(images, (img) => img.decode().catch(() => undefined))
	).then(() => undefined);
	let timer: ReturnType<typeof setTimeout> | undefined;
	const timeout = new Promise<void>((resolve) => (timer = setTimeout(resolve, timeoutMs)));
	return Promise.race([decoded, timeout]).finally(() => clearTimeout(timer));
};
